import {Component, OnInit} from "@angular/core";
import {DossierService} from "../../../../../services";
import {DictionaryService} from "@amlCore/services";
import {AlertPanelService, ITableEditorItem, ITableItem} from "@amlCore/components";
import {DossierBaseModel} from "../../dossierBaseModel";
import {FormGroup} from "@angular/forms";
import {DossierBaseSubComponent} from "../dossierBaseSub.component";
import {UserService} from '@amlCore/services';

@Component({
  selector: 'app-update-card-info-dossier',
  styleUrls: ['../../dossier.css'],
  templateUrl: './updateCardInfoDossier.component.html'
})
export class UpdateCardInfoDossierComponent extends DossierBaseSubComponent implements ITableItem, OnInit {

  titlePanel = 'Обновление анкеты клиента';
  showTitle = true;
  isTableItem = false;

  constructor(protected dossierService: DossierService, protected dictSrv: DictionaryService,
              protected dossierBaseModel: DossierBaseModel,
              protected alertPanelService: AlertPanelService, private userSrv: UserService) {
    super(dossierService, dictSrv, alertPanelService);
  }
  /**
   * Описание формы
   */
  getFormDescription(): FormGroup {
    return this.dossierBaseModel.getUpdateCardInfo();
  }

  /**
   * Инициализация FormGroup
   */
  initForm() {
    if (!this.isTableItem) {
      this.formGroupApp = this.getFormDescription();
    }
  }

  ngOnInit() {
    setTimeout(() => this.initErrorFLKSimpleField());
  }

  setSubmitted(value: boolean) {
    this.submitted = value;
  }


  getTitle(): string {
    return this.titlePanel;
  }

  /**
   * Инициализируем компонент как элемент формы просмотра таблицы
   * @param param.form - форма для связи
   * @param param.params - дополнительные параметры
   */
  initTableItem(param: ITableEditorItem): FormGroup {
    this.initForm();
    this.isTableItem = true;
    if (param.model) {
      this.formGroupApp.patchValue(param.model);
    }
    this.showTitle = false;
    if (param.params && param.params.typePage) {
      this.typePage = param.params.typePage;
    } else {
      console.log('Необходимо указать typePage у компонента');
    }
    this.isReadOnly = param.isReadOnly;
    if (this.isReadOnly){
      this.formGroupApp.disable();
    }else{
	  const currentUser = this.userSrv.getCurrentUser();
	  if(!this.f('fio').value){
	     this.f('fio').setValue(currentUser.fio);
	  }
	  if(!this.f('position').value){
	     this.f('position').setValue(currentUser.position);
      }
      if(!this.f('userId').value){
         this.f('userId').setValue(currentUser.id); 
      } 
    }

    return this.formGroupApp;
  }

}
